import { Action } from "redux";

export type AuthUnlinkRequest = "AUTH_UNLINK_REQUEST";
export const AUTH_UNLINK_REQUEST: AuthUnlinkRequest = "AUTH_UNLINK_REQUEST";

export interface AuthUnlinkRequestAction extends Action {
    type: AuthUnlinkRequest;
}

export function unlink(): AuthUnlinkRequestAction {
    return {
        type: AUTH_UNLINK_REQUEST
    };
}
